import mixpanel from 'mixpanel-browser';

import { objectToSnakeCase } from '#utils/object';

const init = () => {
  mixpanel.init(process.env.REACT_APP_MIXPANEL, { debug: process.env.NODE_ENV === 'development' });
};

const track = (eventName, properties = {}) => {
  mixpanel.track(eventName, objectToSnakeCase(properties));
};

const MixpanelService = {
  init,
  track,
  identify: mixpanel.identify
};

export default MixpanelService;
